import { Icon } from 'shared/iconpack'

import { Spin } from 'shared/ui/Spin'

import { palette } from 'shared/config/styles/palette'

import { Select, SelectProps } from '../Select/Select'

import './SelectWithCheckbox.css'

interface SelectWithCheckboxProps extends SelectProps {
  isLoading?: boolean
}
const SelectWithCheckbox = ({
  className,
  value,
  defaultValue,
  onChange,
  isLoading,
  placeholder,
  ...props
}: SelectWithCheckboxProps) => {
  return (
    <Select
      className={`customSelectQuery ${className} min-w-[200px] ${value && value.length > 0 && 'filledCustomMultiple'}`}
      value={value ?? defaultValue}
      mode="multiple"
      onChange={onChange}
      placeholder={placeholder}
      suffixIcon={
        isLoading ? (
          <Spin size="small" />
        ) : (
          <div className="flex items-center mb-[-3px] mr-[-3px]">
            <Icon
              name="arrowDown"
              width={21}
              height={20}
              color={palette.dark}
            />
          </div>
        )
      }
      maxTagCount={0}
      getPopupContainer={(triggerNode) => triggerNode}
      tagRender={() => {
        return value && value.length > 0 ? (
          <span className="pl-[8px] text-dark_blue_1 leading-[20px] text-[14px]">
            {placeholder}: {value.length}
          </span>
        ) : (
          <span className="pl-[8px]">{placeholder}</span>
        )
      }}
      {...props}
    />
  )
}

export default SelectWithCheckbox
